import React from "react";
import mainContext from "../../../contexts/mainContext";
import { addHouseKeeperIHaveMyOwnController, deleteData, getHouseKeeperIHaveMyOwnController } from "../../../Controllers/AppManagement/houseKeeper";
import { __constants, __snackBarText, __snackBarSeverity } from "../../../constants";
import ImageTextListManager from "../common/ImageTextListManager";

export default function HouseKeeperIHaveMyOwn() {
  const { setProfileNavTitle } = React.useContext(mainContext);
  return (
    <ImageTextListManager
      navTitle="Housekeeper assets"
      dialogTitle="Add i have my own"
      textLabel="I have my own"
      getData={getHouseKeeperIHaveMyOwnController}
      addData={addHouseKeeperIHaveMyOwnController}
      deleteData={deleteData}
      editTitle="Update availability"
      setProfileNavTitle={setProfileNavTitle}
      __constants={__constants}
      __snackBarText={__snackBarText}
      __snackBarSeverity={__snackBarSeverity}
      mainContext={mainContext}
    />
  );
}